import { Box, MenuItem, Select, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useState } from "react";
import { useRecordContext } from "react-admin";
import { useField } from "react-final-form";

import useBranches from "../../../hooks/useBranches";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "150px auto",
    gridGap: 5,
    marginTop: 15,
    marginBottom: 15,
  },
  textStyle: {
    fontSize: 16,
  },
}));

const BranchesSelect = ({ noCurrent, required }) => {
  const classes = useStyles();
  const record = useRecordContext();
  const {
    input: { onChange },
    meta: { error, touched },
  } = useField("branchSelected");
  const [selectedBranches] = useState([]);
  const handleSelect = (e) => {
    onChange([...e.target.value]);
  };
  return (
    <Box className={classes.container}>
      <Box style={{ display: "flex" }}>
        <Typography className={classes.textStyle}>Branches</Typography>
        {required ? (
          <Typography className={classes.textStyle} style={{ color: "orange" }}>
            *
          </Typography>
        ) : null}
      </Box>
      <BranchSelect
        noCurrent={noCurrent}
        value={selectedBranches}
        onChange={handleSelect}
        defaultValue={record.branches?.map((branch) => branch.id)}
        error={error}
        touched={touched}
      />
    </Box>
  );
};

const BranchSelect = ({
  noCurrent,
  selectedBranches,
  defaultValue,
  onChange,
  error: dataError,
  touched,
}) => {
  const { branches, loading, error } = useBranches();
  if (loading) return null;
  if (error) return null;
  return (
    <Box>
      <Select
        multiple
        defaultValue={[]}
        onChange={onChange}
        value={selectedBranches}
        style={{ width: 300 }}
        // fullWidth
      >
        {branches?.map((branch) => (
          <MenuItem value={branch.id}>{branch.name}</MenuItem>
        ))}
      </Select>
      {noCurrent ? null : (
        <Typography>
          Current branches:{" "}
          {defaultValue
            ?.map((v) => branches.find((b) => b.id === v).name)
            .join(", ")}
        </Typography>
      )}
      {dataError && touched ? (
        <Typography variant="caption" style={{ color: "red" }}>
          {dataError}
        </Typography>
      ) : null}
    </Box>
  );
};

export default BranchesSelect;
